module.exports = __webpack_public_path__ + "img/2.09ae75d9.jpg";